import {
    fetch_content_graphql,
    fetch_content_preview,
} from "../../actions/Content/dispatchers";
import { fetch_sectional_content_graphql } from "../../actions/SectionalContent/dispatchers";
import { reset_right_rail } from "../../reducers/RightRail/reducer";
import { fetch_supplementary_data } from "../../actions/RightRail/dispatchers";
import { setAppState, setAppError } from "../../actions/App/dispatchers";
import { fetch_tracking } from "../../actions/Tracking/dispatchers";
import { page_initial_data } from "../../reducers/Page/reducer";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";
import swimlaneList from "../../actions/SwimlaneList/actions";
import { REGION_LIST_COUNT } from "../../constants/regions";
import { getWidgetNames, getWidgetDefs } from "../../utils/widgets/library";
import log from "../../utils/logger/library";
import { previewType } from "../../utils/page/library";
import { fetch_newsletters_if_needed } from "../../actions/Newsletters/actions";

/**
 * Fetch content for all widgets on page with a content dependency
 * @param {string} path no leading /
 * @return {Promise}
 */
export const fetch_widgets_content = (path) => (dispatch) => {
    const widgets = getWidgetDefs(getWidgetNames(path));
    return Promise.all(
        widgets
            .filter((widget) => widget && widget.type === "contentlist")
            .map((widget) =>
                dispatch(
                    fetch_sectional_content_graphql(
                        widget.path,
                        widget.count || REGION_LIST_COUNT
                    )
                )
            )
    );
};

export const fetchLandingPageData = (path, params) => (dispatch, getState) => {
    let url = path.slice(1);
    const preview = previewType(path);

    let previewId;
    if (preview) {
        url = path
            .replace(/\/meta\/(nine-)?preview\//i, "")
            .replace(`/${params.contentId}`, "");
        path = path
            .replace(/\/meta\/(nine-)?preview/i, "")
            .replace(`/${params.contentId}`, "");
        previewId = params.contentId;
    }

    dispatch(reset_app_state(path));
    dispatch(reset_right_rail());

    const mainContent = !preview
        ? dispatch(fetch_content_graphql({ section: url }))
        : dispatch(fetch_content_preview({ section: url, previewId, preview }));

    return mainContent
        .then(() => {
            return Promise.all([
                dispatch(fetch_tracking()),
                dispatch(fetch_widgets_content(url)),
                dispatch(fetch_supplementary_data(url)),
                dispatch(page_initial_data({})),
                dispatch(swimlaneList(url)),
            ])
                .then(() => {
                    const state = getState();
                    const pageSections = state?.page?.sections || null;
                    return Promise.resolve([
                        dispatch(fetch_newsletters_if_needed(pageSections)),
                        dispatch(setAppState(path, false, "")),
                    ]);
                })
                .catch((error) => {
                    log.error("(fetchLandingPageData)", error);
                });
        })
        .catch((error) => {
            dispatch(setAppError(path, error.code));
        });
};
